<template>
  <div class="user" data-testid="user" @click="$emit('userClicked')">
    <UserAvatar :account="account" :size="avatarSize" fontSize="10px" />
    <div class="ml-2">
      <div class="user__content">
        <router-link
          v-if="orgId && accountId"
          class="user__name ma-0 text-decoration-none "
          :style="{ 'font-size': fontSize }"
          :to="`/profile/${orgId}/${accountId}`"
          >{{ userName }}</router-link
        >
        <p v-else class="user__name ma-0">{{ userName }}</p>
        <p
          class="text-caption grey--text text--darken-2 ma-0 user__secondary-text"
          v-if="secondaryText"
        >
          {{ secondaryText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue'
import UserMixin from '@/mixins/userMixin.vue'
import getEntityId from '../../lib/getEntityId'

export default {
  name: 'User',

  mixins: [UserMixin],

  components: {
    UserAvatar,
  },

  props: {
    avatarSize: {
      type: String,
      required: false,
      default: '32px',
    },
    fontSize: {
      type: String,
      required: false,
      default: '14px',
    },
    userId: {
      type: String,
      required: false,
    },

    organizationId: {
      type: String,
      required: false,
    },

    account: {
      type: Object,
      required: true,
    },

    name: {
      type: String,
      required: false,
    },

    secondaryText: {
      type: String,
      required: false,
    },
  },

  computed: {
    userName() {
      return this.name ?? this.getFullName(this.account)
    },

    accountId() {
      return this.userId ?? getEntityId(this.account) ?? null
    },

    orgId() {
      return (
        this.organizationId ?? getEntityId(this.account?.organization) ?? null
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.user {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.user__meta {
  margin-left: 16px;
  flex: 1;
}

.user__content {
  width: 100%;
}

.user__name {
  color: $color-blue-grey-darken3;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;

  &:hover {
    color: $color-blue;
  }
}
</style>
